import React from 'react';
import { Alert, Box, useMediaQuery, useTheme } from '@mui/material';
import { ControlUnitsListProps } from '../../../../../../components/DeviceManager/ControlUnit/ControlUnitsList/ControlUnitsList';
import { getPolyglot } from '../../../../../../i18n';
import ControlUnitCardGrid from '../../../../../../components/DeviceManager/ControlUnit/ControlUnitCardGrid';

function StoreDemoControlUnitsListGrid(props: ControlUnitsListProps) {
  const { controlUnits, deviceId, groupId } = props;
  const polyglot = getPolyglot();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  const smartSwitchCU = controlUnits?.filter((controlUnit) =>
    ['900000000'].some((version) =>
      controlUnit?.version?.prod?.includes(version)
    )
  );
  const stBusCU = controlUnits?.filter(
    (controlUnit) =>
      smartSwitchCU?.findIndex((ssCU) => ssCU.id === controlUnit.id) === -1
  );
  return (
    <>
      <Box
        sx={{
          padding: 2,
          display: 'flex',
          flexWrap: 'wrap',
          justifyContent: 'flex-start',
          alignItems: 'space-between',
          gap: '42px',
          mb: 2,
        }}
      >
        {stBusCU?.map((controlUnit) => {
          return (
            <ControlUnitCardGrid
              key={controlUnit.id}
              controlUnit={controlUnit}
              deviceId={deviceId}
              groupId={groupId}
            />
          );
        })}
      </Box>
      {smartSwitchCU?.length ? (
        <Box
          sx={{
            padding: 2,
            display: 'flex',
            flexWrap: 'wrap',
            justifyContent: 'start',
            alignItems: 'start',
            gap: '42px',
            mb: 6,
            backgroundColor: '#DFDFDF',
          }}
        >
          {smartSwitchCU?.map((controlUnit) => {
            return (
              <ControlUnitCardGrid
                key={controlUnit.id}
                controlUnit={controlUnit}
                deviceId={deviceId}
                groupId={groupId}
              />
            );
          })}
        </Box>
      ) : null}
      <Alert
        severity="info"
        sx={{
          position: 'fixed',
          bottom: isMobile ? '160px' : '90px',
          left: '50%',
          transform: 'translate(-50%)',
          fontSize: '0.8rem',
          alignItems: 'center',
        }}
      >
        {polyglot.t('device.controlUnit.synchronization')}
      </Alert>
    </>
  );
}

export default StoreDemoControlUnitsListGrid;
